import dayjs from 'dayjs';

export const formatTimeRange = (timestamp: number, type?: string) => {
  const time = dayjs.unix(timestamp);
  if (type === 'day') {
    return time.format('ddd');
  }
  return time.format('h A');
};

export const timeTo24Hour = (time: string) => {
  const [hour, period] = time.split(' ');
  let hourNum = parseInt(hour, 10);
  if (period === 'PM' && hourNum !== 12) hourNum += 12;
  if (period === 'AM' && hourNum === 12) hourNum = 0;
  return hourNum;
};
